import './inbox_content.js.coffee'
import './inbox_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.TwitterGifAttachment extends Backbone.Model

  initialize: (media) =>
    @media = media

  url:=>
    @media.video_info.variants[0].url

  is_twitter_gif: =>
    true
  
  is_twitter_video:=>
    false
